import { DaysOfWeek } from './enums/days-of-week';

export class Calendar {
    public id: string;
    public organizationId: string;
    public name: string;
    public nextId: string;
    public days: string;
    public dates: string[] = [];
    public hours: string[] = [];
}
